import { type WidgetApps, type Provider, type TaskName } from '@/types'

type AppTask = TaskName | TaskName[]

const apps: Record<WidgetApps, {
    task?: TaskName | TaskName[]
    provider?: Provider
}> = {
    'custom-page': {
        task: ['CUSTOM_PAGE', 'CUSTOM_PAGE_2'],
    },
    'transactionlink-open-banking': {
        task: 'OPEN_BANKING',
        provider: 'TRANSACTION_LINK',
    },
    'workflow-finish': {},
    'zoho-sign': {
        provider: 'ZOHO_SIGN',
        task: 'SIGNATURE',
    },
    'edo-app': {
        provider: 'EDO_APP',
        task: 'EDO_APP',
    },
    'p24-verification-payment': {
        provider: 'PRZELEWY24',
        task: 'VERIFICATION_PAYMENT',
    },
    'veriff-video-verification': {
        provider: 'VERIFF',
        task: 'VIDEO_VERIFICATION',
    },
    'veriff-age-estimation': {
        provider: 'VERIFF',
        task: 'AGE_ESTIMATION',
    },
    'comply-cube-video-verification' : {
        provider: 'COMPLY_CUBE',
        task: 'VIDEO_VERIFICATION',
    },
    'transactionlink-sms-verification': {
        provider: 'SMS_API',
        task: 'SMS_VERIFICATION',
    },
    twilio: {
        provider: 'TWILIO',
        task: 'VERIFY',
    },
    'ondato-vv': {
        provider: 'ON_DATO',
        task: 'VIDEO_VERIFICATION',
    },
    'idenfy-video-verification': {
        provider: 'IDENFY',
        task: 'VIDEO_VERIFICATION',
    },
    yapily: {
        provider: 'YAPILY',
        task: 'AIS',
    },
    'moje-id-verification': {
        provider: 'MOJE_ID',
        task: 'ID_VERIFICATION',
    },
    'gbg-id-verification': {
        provider: 'GBG',
        task: 'ID_VERIFICATION',
    },
    'autopay-verification-payment': {
        provider: 'AUTO_PAY',
        task: 'VERIFICATION_PAYMENT',
    },
    'mobywatel-id-verification': {
        provider: 'MOBYWATEL',
        task: 'ID_VERIFICATION',
    },
    'smart-id-verification': {
        provider: 'SMART_ID',
        task: 'ID_VERIFICATION',
    },
    'bank-id-norway-verification': {
        provider: 'BANK_ID_NORWAY',
        task: 'ID_VERIFICATION',
    },
    'bank-id-denmark-verification': {
        provider: 'BANK_ID_DENMARK',
        task: 'ID_VERIFICATION',
    },
    'comply-cube-face-authentication': {
        provider: 'COMPLY_CUBE',
        task: 'FACE_AUTHENTICATION',
    },
    'bank-id-czechia-verification': {
        provider: 'BANK_ID_CZECHIA',
        task: 'ID_VERIFICATION',
    },
    'bank-id-finland-verification': {
        provider: 'BANK_ID_FINLAND',
        task: 'ID_VERIFICATION',
    },
    'au10tix-video-verification': {
        provider: 'AU10TIX',
        task: 'VIDEO_VERIFICATION',
    },
}

const checkTaskEquality = (appTask: AppTask, task: TaskName) => {
    if (Array.isArray(appTask)) {
        return appTask.includes(task)
    }
    return appTask === task
}

const getAppName = (task: TaskName, provider: Provider): WidgetApps | null => {
    for (const key in apps) {
        const app = apps[key as WidgetApps]
        if (app.provider === provider && checkTaskEquality(app.task || '', task)) {
            return key as WidgetApps
        }
    }
    return null
}

export default getAppName
